import { PER_WEIGHT_UNITS } from "../../../../../config/optionsConstants";

export const WEIGHT_UNIT_OPTIONS = PER_WEIGHT_UNITS.map(o => ({ value: o.value, label: o.text }));
